import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { Form } from "./Form";
import { Table } from "./Table";
import { IPermissionProps } from "../../../../models/Login";
import { QuestionLink } from "./QuestionLink";

interface IProps {
    open: boolean,
    singleData: any,
    hideDialog: () => void,
    toast: any,
}

export const TrainingTopics = (permission: IPermissionProps) => {
    const [modal, setModal] = useState({ singleData: {}, open: false });
    const [questionModal, setQuestionModal] = useState<{ open: boolean; topic_ID: number | null; }>({ open: false, topic_ID: null });
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => setModal({ singleData: {}, open: false });
    const reloadTable = () => setReload(!reload);

    return (
        <>
            {(permission.is_Create || permission.is_Update) && <Form open={modal.open} singleData={modal.singleData} hideDialog={hideDialog} reloadTable={reloadTable} toast={toast} />}
            <QuestionLink open={questionModal.open} topic_ID={questionModal.topic_ID} hideDialog={() => setQuestionModal({ open: false, topic_ID: null })} toast={toast} />
            <Table
                setModal={setModal}
                permissions={permission}
                openQuestionModal={(topic_ID: number) => setQuestionModal({ open: true, topic_ID })}
                reload={reload}
                toast={toast}
            />

            <Toast ref={toast} />
        </>
    );
}
